export function captureActiveElement() {
  return typeof document !== 'undefined' ? document.activeElement : null;
}

export function focusPageContentOnRouteChange(to) {
  if (to && to.hash) {
    return;
  }
  const target = typeof document !== 'undefined' ? document.getElementById('app-main-content') : null;
  if (!target || typeof target.focus !== 'function') {
    return;
  }
  requestAnimationFrame(() => {
    try {
      target.focus({preventScroll: true});
    } catch (e) {
      target.focus();
    }
  });
}

export function focusFirstElement(container, {prefer} = {}) {
  if (!container) {
    return;
  }

  const isFocusableElement = element => {
    if (!element || element.disabled) {
      return false;
    }
    if (element.getAttribute('aria-hidden') === 'true') {
      return false;
    }
    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }
    return element.getClientRects().length > 0;
  };

  const findFocusable = elements => Array.from(elements).find(isFocusableElement);
  const focusSelectors = typeof prefer === 'string' ? [prefer] : Array.isArray(prefer) ? prefer.filter(Boolean) : [];

  for (const selector of focusSelectors) {
    const preferredFocusable = findFocusable(container.querySelectorAll(selector));
    if (preferredFocusable) {
      preferredFocusable.focus();
      return;
    }
  }

  const focusables = container.querySelectorAll(
    'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  );
  const firstFocusable = findFocusable(focusables);
  const target = firstFocusable || container;
  if (target && typeof target.focus === 'function') {
    target.focus();
  }
}

export function restoreFocus(element) {
  if (element && typeof element.focus === 'function') {
    element.focus();
  }
}
